import { BoxProps, Heading } from '@chakra-ui/react';
import { QuoteShareContactsForm } from '@monetize/types/app';
import lodashGet from 'lodash/get';
import { Controller, useFormContext } from 'react-hook-form';
import { AddressForm } from '../../../components/Contacts/AddressForm';
import {
  MBox,
  MFormField,
  MGrid,
  MGridItem,
  MInput,
} from '../../../components/Monetize';

interface QuoteShareContactProps extends BoxProps {
  label: string;
  formKeyPrefix: 'billingContact' | 'shippingContact';
  requireAddress: boolean;
}

export const QuoteShareContact = ({
  label,
  formKeyPrefix,
  requireAddress,
  ...boxProps
}: QuoteShareContactProps) => {
  const formMethods = useFormContext<QuoteShareContactsForm>();
  const {
    control,
    formState: { errors: rootErrors },
  } = formMethods;

  const errors = lodashGet(rootErrors, formKeyPrefix) || {};

  return (
    <MBox {...boxProps}>
      <Heading as="h3" fontSize="sm" mb={2}>
        {label}
      </Heading>
      <MGrid templateColumns="repeat(12, 1fr)" gap={4}>
        <MGridItem colSpan={[12, 12, 6, 3]}>
          <MFormField error={errors?.fullName} label="Name" isRequired>
            <Controller
              name={`${formKeyPrefix}.fullName`}
              control={control}
              defaultValue=""
              render={({ field }) => <MInput {...field} />}
            />
          </MFormField>
        </MGridItem>

        <MGridItem colSpan={[12, 12, 6, 3]}>
          <MFormField error={errors?.email} label="Email" isRequired>
            <Controller
              name={`${formKeyPrefix}.email`}
              control={control}
              defaultValue=""
              render={({ field }) => <MInput {...field} />}
            />
          </MFormField>
        </MGridItem>

        <MGridItem colSpan={[12, 12, 6, 3]}>
          <MFormField error={errors?.title} label="Job Title">
            <Controller
              name={`${formKeyPrefix}.title`}
              control={control}
              defaultValue=""
              render={({ field: { value, ...rest } }) => (
                <MInput {...rest} value={value || ''} />
              )}
            />
          </MFormField>
        </MGridItem>

        <MGridItem colSpan={[12, 12, 6, 3]}>
          <MFormField error={errors?.phone} label="Phone">
            <Controller
              name={`${formKeyPrefix}.phone`}
              control={control}
              defaultValue=""
              render={({ field: { value, ...rest } }) => (
                <MInput value={value || ''} {...rest} />
              )}
            />
          </MFormField>
        </MGridItem>
        <MGridItem colSpan={12}>
          <AddressForm
            formKeyPrefix={`${formKeyPrefix}.address.`}
            requireAddress={requireAddress}
          />
        </MGridItem>
      </MGrid>
    </MBox>
  );
};
